import React, { createContext, useState, useCallback } from 'react'

import NotificationModal, { NotificationModalProps } from '@components/NotificationModal'

export const NotificationContext = createContext<NotificationContextValue | null>(null)

export interface NotificationModalProviderProps {
  children: React.ReactNode
}

export const NotificationModalProvider = ({ children }: NotificationModalProviderProps) => {
  const [modalState, setModalState] = useState<Omit<NotificationModalProps, 'onClose'> | null>(null)

  const showNotificationModal = useCallback<ShowNotificationModalAction>(payload => {
    setModalState({ opened: true, ...payload })
  }, [])

  const handleClose = () => setModalState(prev => prev && { ...prev, opened: false })

  return (
    <>
      <NotificationContext.Provider value={{ showNotificationModal }}>{children}</NotificationContext.Provider>
      {!!modalState && (
        <NotificationModal
          opened={modalState.opened}
          type={modalState.type}
          text={modalState.text}
          title={modalState.title}
          onClose={handleClose}
        />
      )}
    </>
  )
}
